module.exports = __webpack_public_path__ + "static/media/happily_ever_after.7849c9a6.jpg";